var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoicesIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.16732 9.16406H6.66732M11.6673 5.83073H6.66732M3.33398 15.5357V6.70906C3.33398 4.33073 3.33398 3.1424 4.06648 2.40323C4.79815 1.66406 5.97732 1.66406 8.33398 1.66406H11.6673C14.024 1.66406 15.2032 1.66406 15.9348 2.40323C16.6673 3.14156 16.6673 4.33073 16.6673 6.70906V15.5357C16.6673 16.7949 16.6673 17.4249 16.2823 17.6732C15.6531 18.0782 14.6806 17.2282 14.1915 16.9199C13.7873 16.6649 13.5856 16.5382 13.3606 16.5307C13.119 16.5224 12.9131 16.6449 12.4765 16.9199L10.884 17.9241C10.454 18.1949 10.2398 18.3307 10.0007 18.3307C9.76148 18.3307 9.54732 18.1949 9.11732 17.9241L7.52565 16.9199C7.12065 16.6649 6.91898 16.5382 6.69482 16.5307C6.45232 16.5224 6.24648 16.6449 5.80982 16.9199C5.32065 17.2282 4.34815 18.0782 3.71815 17.6732C3.33398 17.4249 3.33398 16.7957 3.33398 15.5357Z",
    stroke: "#FCFCFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicesIcon);
export default __webpack_public_path__ + "static/media/invoicesIcon.996933dc029d8acc35066f122752c7af.svg";
export { ForwardRef as ReactComponent };